import React, { useEffect, useMemo, useRef, useState } from "react";
import { ApiConnectionString } from "../constants/ApiConntection";
import axios from "axios";
import { useAuthContext } from "../hooks/useAuthContext";
import ServicesSection from "./ServicesSection";
import ExtraSectionsSection from "./ExtraSectionsSection";
import LinksSection from "./LinksSection";
import PracticeImages from "./PracticeImages";
import logo from "../assets/logo.png";
import "./CounsellorSiteBriefFormTwo.css";
import Login from "../components/modals/Login";
import FormCompleteModal from "./FormCompleteModal"
import LoadingSpinner from "../components/LoadingSpinner";

import beach from "../assets/heros/beach.png";
import calmradiance from "../assets/heros/calmradiance.png";
import forrest from "../assets/heros/forrest.png";
import landscape from "../assets/heros/landscape.png";
import quietroom from "../assets/heros/quietroom.png";
import river from "../assets/heros/river.png";
import room from "../assets/heros/room.png";
import windowplant from "../assets/heros/window.png";
import balance from "../assets/heros/balance.png";
import { useNavigate } from "react-router-dom";



export default function CounsellorSiteBriefFormTwo() {


  const palettes = useMemo(
    () => [
      {
        id: "warm",
        name: "Warm neutral",
        background: "#F7F3EE",
        surface: "#FFFFFF",
        section: "#F3EADF",
        text: "#1F2B2A",
        muted: "#5F6D6A",
        brand: "#6B7C75",
        border: "#E4DAD0",
        footer: "#1E2322",
      },
      {
        id: "sage",
        name: "Sage and cream",
        background: "#F6F8F6",
        surface: "#FFFFFF",
        section: "#EEF3EF",
        text: "#1F2B2A",
        muted: "#5E6B65",
        brand: "#4F6F63",
        border: "#DDE6E1",
        footer: "#1B2321",
      },
      {
        id: "bluegrey",
        name: "Soft blue grey",
        background: "#F5F7FA",
        surface: "#FFFFFF",
        section: "#EEF2F6",
        text: "#1E2A33",
        muted: "#576574",
        brand: "#4C6475",
        border: "#DCE3EA",
        footer: "#1B232B",
      },
      {
        id: "rose",
        name: "Dusty rose",
        background: "#FAF6F7",
        surface: "#FFFFFF",
        section: "#F4EAEC",
        text: "#2B1F24",
        muted: "#6D5B62",
        brand: "#7A5A66",
        border: "#E7D7DD",
        footer: "#241A1F",
      },
      {
        id: "deepgreen",
        name: "Deep calm green",
        background: "#F6F7F6",
        surface: "#FFFFFF",
        section: "#EDEFEA",
        text: "#172423",
        muted: "#556360",
        brand: "#2F5D50",
        border: "#D9DED7",
        footer: "#0F1E1B",
      },
      {
        id: "mono",
        name: "Minimal warm",
        background: "#F7F7F5",
        surface: "#FFFFFF",
        section: "#F0EEE9",
        text: "#1D1D1B",
        muted: "#5F5F59",
        brand: "#3E3E3A",
        border: "#E3E1DA",
        footer: "#1A1A18",
      },
    ],
    []
  );

  const heroOptions = [
    { id: "balance", label: "Balance", src: balance },
    { id: "beach", label: "Beach", src: beach },
    { id: "calmradiance", label: "Calm radiance", src: calmradiance },
    { id: "forrest", label: "Forrest", src: forrest },
    { id: "landscape", label: "Landscape", src: landscape },
    { id: "quietroom", label: "Quiet room", src: quietroom },
    { id: "river", label: "River", src: river },
    { id: "room", label: "Room", src: room },
    { id: "windowplant", label: "Window plant", src: windowplant },
  ];

  const { user } = useAuthContext();
  const [id, setId] = useState(null);
  const [practiceName, setPracticeName] = useState("");
  const [tagline, setTagline] = useState("");
  const [locationCity, setLocationCity] = useState("");
  const [offersOnline, setOffersOnline] = useState(true);
  const [offersInPerson, setOffersInPerson] = useState(true);

  const [paletteId, setPaletteId] = useState("warm");
  const [bgImage, setBgImage] = useState("balance");

  const [displayName, setDisplayName] = useState("");
  const [introBlurb, setIntroBlurb] = useState("");
  const [aboutLong, setAboutLong] = useState("");
  const [qualifications, setQualifications] = useState("");
  const [memberships, setMemberships] = useState("");
  const [areasOfFocus, setAreasOfFocus] = useState("");
  const [experience, setExperience] = useState("");

  const [servicesIntro, setServicesIntro] = useState("");

  const [approachSummary, setApproachSummary] = useState("");
  const [sessionLengthMinutes, setSessionLengthMinutes] = useState("50");
  const [whatToExpect, setWhatToExpect] = useState("");

  const [sessionFee, setSessionFee] = useState("");
  const [feeNotes, setFeeNotes] = useState("");
  const [concessions, setConcessions] = useState("");
  const [cancellationPolicy, setCancellationPolicy] = useState("");

  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [preferredMethod, setPreferredMethod] = useState("email");
  const [replyTime, setReplyTime] = useState("24 to 48 hours");
  const [nextSteps, setNextSteps] = useState("");

  const [workingHours, setWorkingHours] = useState("");
  const [ageRange, setAgeRange] = useState("");
  const [onlinePlatform, setOnlinePlatform] = useState("");
  const [accessibilityNotes, setAccessibilityNotes] = useState("");
  const [parkingNotes, setParkingNotes] = useState("");
  const [anythingElseNotes, setAnythingElseNotes] = useState("");

  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const [complete,setComplete] = useState(false)

  const [isLoading, setIsloading] = useState(false);

  const formRef = useRef(null);

  const lastSavedRef = useRef({});
  const saveAbortRef = useRef(null);

  const openAccordionForField = (el) => {
    const collapse = el.closest(".accordion-collapse");
    if (!collapse) return;

    if (window.bootstrap?.Collapse) {
      window.bootstrap.Collapse.getOrCreateInstance(collapse).show();
    } else {
      collapse.classList.add("show");
    }
  };

  const validateAndFocusFirstInvalid = () => {
    const formEl = formRef.current;
    if (!formEl) return false;

    formEl.classList.add("was-validated");

    const sessionsErrorEl = formEl.querySelector("#sessionsError");
    if (sessionsErrorEl) sessionsErrorEl.textContent = "";

    if (!offersOnline && !offersInPerson) {
      if (sessionsErrorEl) sessionsErrorEl.textContent = "Select at least one option";
      const firstSessionsInput = formEl.querySelector("#offersOnline");
      if (firstSessionsInput) {
        openAccordionForField(firstSessionsInput);
        firstSessionsInput.focus();
        firstSessionsInput.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
      return false;
    }

    const ok = formEl.checkValidity();
    if (!ok) {
      const firstInvalid = formEl.querySelector(":invalid");
      if (firstInvalid) {
        openAccordionForField(firstInvalid);

        firstInvalid.classList.add("is-invalid");

        firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
        firstInvalid.focus({ preventScroll: true });

        const clear = () => {
          firstInvalid.classList.remove("is-invalid");
          firstInvalid.removeEventListener("input", clear);
          firstInvalid.removeEventListener("change", clear);
        };

        firstInvalid.addEventListener("input", clear);
        firstInvalid.addEventListener("change", clear);
      }
      return false;
    }

    return true;
  };

  const buildPayload = () => {
    return {
      PracticeName: practiceName,
      Tagline: tagline,
      LocationCity: locationCity,
      OffersOnline: offersOnline,
      OffersInPerson: offersInPerson,
      PaletteId: paletteId,
      bgImage: bgImage,
      DisplayName: displayName,
      IntroBlurb: introBlurb,
      AboutLong: aboutLong,
      Qualifications: qualifications,
      Memberships: memberships,
      AreasOfFocus: areasOfFocus,
      Experience: experience,
      ServicesIntro: servicesIntro,
      ApproachSummary: approachSummary,
      SessionLengthMinutes: String(sessionLengthMinutes || "0"),
      WhatToExpect: whatToExpect,
      SessionFee: sessionFee,
      FeeNotes: feeNotes,
      Concessions: concessions,
      CancellationPolicy: cancellationPolicy,
      Phone: phone,
      Email: email,
      PreferredMethod: preferredMethod,
      ReplyTime: replyTime,
      NextSteps: nextSteps,
      WorkingHours: workingHours,
      AgeRange: ageRange,
      OnlinePlatform: onlinePlatform,
      AccessibilityNotes: accessibilityNotes,
      ParkingNotes: parkingNotes,
      AnythingElseNotes: anythingElseNotes,
    };
  };

  const saveOnBlur = async () => {
    if (!user) return;

    const next = buildPayload();
    const prev = lastSavedRef.current || {};

    const changed = Object.keys(next).some((k) => next[k] !== prev[k]);
    if (!changed) return;

    if (saveAbortRef.current) saveAbortRef.current.abort();
    saveAbortRef.current = new AbortController();

    try {
      await axios.put(`${ApiConnectionString}/api/counsellingForm`, next, {
        headers: { Authorization: `bearer ${user.token}` },
        signal: saveAbortRef.current.signal,
      });

      lastSavedRef.current = { ...prev, ...next };
      setSubmitSuccess(true);
      setSubmitError("");
    } catch (err) {
      const aborted =
        err?.name === "CanceledError" ||
        err?.name === "AbortError" ||
        err?.code === "ERR_CANCELED";
      if (aborted) return;

      setSubmitSuccess(false);
      setSubmitError(err?.response?.data || err?.message || "Something went wrong");
    }
  };

  const fetchData = async () => {
    setIsloading(true);

    try {
      const response = await axios.get(`${ApiConnectionString}/api/CounsellingForm`, {
        headers: { Authorization: `bearer ${user.token}` },
      });

      const d = response.data || {};



      setId(d.id);
      setComplete(d.complete)

      setPracticeName(d.practiceName ?? "");
      setTagline(d.tagline ?? "");
      setLocationCity(d.locationCity ?? "");
      setOffersOnline(d.offersOnline ?? true);
      setOffersInPerson(d.offersInPerson ?? true);

      setPaletteId(d.paletteId || "warm");
      setBgImage(d.bgImage || "balance");

      setDisplayName(d.displayName ?? "");
      setIntroBlurb(d.introBlurb ?? "");
      setAboutLong(d.aboutLong ?? "");
      setQualifications(d.qualifications ?? "");
      setMemberships(d.memberships ?? "");
      setAreasOfFocus(d.areasOfFocus ?? "");
      setExperience(d.experience ?? "");

      setServicesIntro(d.servicesIntro ?? "");

      setApproachSummary(d.approachSummary ?? "");
      setSessionLengthMinutes(
        d.sessionLengthMinutes !== null && d.sessionLengthMinutes !== undefined
          ? String(d.sessionLengthMinutes)
          : "50"
      );
      setWhatToExpect(d.whatToExpect ?? "");

      setSessionFee(d.sessionFee ?? "");
      setFeeNotes(d.feeNotes ?? "");
      setConcessions(d.concessions ?? "");
      setCancellationPolicy(d.cancellationPolicy ?? "");

      setPhone(d.phone ?? "");
      setEmail(d.email ?? "");
      setPreferredMethod(d.preferredMethod || "email");
      setReplyTime(d.replyTime || "24 to 48 hours");
      setNextSteps(d.nextSteps ?? "");

      setWorkingHours(d.workingHours ?? "");
      setAgeRange(d.ageRange ?? "");
      setOnlinePlatform(d.onlinePlatform ?? "");
      setAccessibilityNotes(d.accessibilityNotes ?? "");
      setParkingNotes(d.parkingNotes ?? "");
      setAnythingElseNotes(d.anythingElseNotes ?? "");

      lastSavedRef.current = {
        PracticeName: d.practiceName ?? "",
        Tagline: d.tagline ?? "",
        LocationCity: d.locationCity ?? "",
        OffersOnline: d.offersOnline ?? true,
        OffersInPerson: d.offersInPerson ?? true,
        PaletteId: d.paletteId || "warm",
        bgImage: d.bgImage || "balance",
        DisplayName: d.displayName ?? "",
        IntroBlurb: d.introBlurb ?? "",
        AboutLong: d.aboutLong ?? "",
        Qualifications: d.qualifications ?? "",
        Memberships: d.memberships ?? "",
        AreasOfFocus: d.areasOfFocus ?? "",
        Experience: d.experience ?? "",
        ServicesIntro: d.servicesIntro ?? "",
        ApproachSummary: d.approachSummary ?? "",
        SessionLengthMinutes:
          d.sessionLengthMinutes !== null && d.sessionLengthMinutes !== undefined
            ? String(d.sessionLengthMinutes)
            : "50",
        WhatToExpect: d.whatToExpect ?? "",
        SessionFee: d.sessionFee ?? "",
        FeeNotes: d.feeNotes ?? "",
        Concessions: d.concessions ?? "",
        CancellationPolicy: d.cancellationPolicy ?? "",
        Phone: d.phone ?? "",
        Email: d.email ?? "",
        PreferredMethod: d.preferredMethod || "email",
        ReplyTime: d.replyTime || "24 to 48 hours",
        NextSteps: d.nextSteps ?? "",
        WorkingHours: d.workingHours ?? "",
        AgeRange: d.ageRange ?? "",
        OnlinePlatform: d.onlinePlatform ?? "",
        AccessibilityNotes: d.accessibilityNotes ?? "",
        ParkingNotes: d.parkingNotes ?? "",
        AnythingElseNotes: d.anythingElseNotes ?? "",
      };
    } catch (error) {
      console.log(error);
    } finally {
      setIsloading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchData();
    }
  }, [user]);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitError("");
    setSubmitSuccess(false);

    if (!validateAndFocusFirstInvalid()) return;

    setSubmitting(true);

    try {
      const payload = buildPayload();
      await axios.post(`${ApiConnectionString}/api/counsellingForm`, payload, {
        headers: { Authorization: `bearer ${user.token}` },
      });
      lastSavedRef.current = payload;
      setSubmitSuccess(true);
      setComplete(true)
    } catch (err) {
      setSubmitError(err?.response?.data || err?.message || "Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  const selected = palettes.find((p) => p.id === paletteId) || palettes[0];

  const swatches = [
    { label: "Background", value: selected.background },
    { label: "Surface", value: selected.surface },
    { label: "Section", value: selected.section },
    { label: "Text", value: selected.text },
    { label: "Muted", value: selected.muted },
    { label: "Brand", value: selected.brand },
    { label: "Border", value: selected.border },
    { label: "Footer", value: selected.footer },
  ];

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="justify-content-center">
 {complete &&     <FormCompleteModal />}
      {!user && <Login />}
      <div className="d-flex flex-column align-items-center text-center mb-4">
        <div className="d-flex align-items-center gap-3 mb-3">
          <img src={logo} alt="Border City Software Logo" className="logo" />

          <div className="text-start lh-1">
            <div className="fw-bold fs-4">Border City</div>
            <div className="fw-normal fs-4">Software</div>
            <div className="text-muted small mt-1">Website brief</div>
          </div>
        </div>

        <h1 className="fw-bold mb-2">Counsellor website details form</h1>

        <div className="text-muted mb-3">
          Fill this in so we can build your pages using your wording and choices.
        </div>

        <div className="d-flex flex-wrap justify-content-center gap-2">
          <span className="badge text-bg-light border">We save your progress when you leave a field</span>
          <span className="badge text-bg-light border">If something does not apply, type NA</span>
        </div>
      </div>

      <form ref={formRef} onSubmit={submit} className="card border-0 shadow-sm" noValidate>
        <div className="card-body p-4 p-md-5">
          <div className="accordion" id="siteBriefAccordion">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingBasics">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseBasics"
                  aria-expanded="true"
                  aria-controls="collapseBasics"
                >
                  Basics
                </button>
              </h2>
              <div
                id="collapseBasics"
                className="accordion-collapse collapse show"
                aria-labelledby="headingBasics"
                data-bs-parent="#siteBriefAccordion"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-12 col-md-6">
                      <label className="form-label">Practice name or your name</label>
                      <div className="form-text">This is what shows in your header.</div>
                      <input
                        className="form-control"
                        required
                        value={practiceName}
                        onChange={(e) => setPracticeName(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="Counselling Practice"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Tagline</label>
                      <div className="form-text">One short sentence that sums up what you offer.</div>
                      <input
                        className="form-control"
                        required
                        value={tagline}
                        onChange={(e) => setTagline(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="A calm space to talk things through"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">City or town</label>
                      <div className="form-text">If you work online only, put the nearest city.</div>
                      <input
                        className="form-control"
                        required
                        value={locationCity}
                        onChange={(e) => setLocationCity(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="Manchester"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Sessions</label>
                      <div className="form-text">Choose at least one option.</div>
                      <div className="d-flex flex-wrap gap-3 pt-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="offersOnline"
                            checked={offersOnline}
                            onChange={(e) => setOffersOnline(e.target.checked)}
                            onBlur={saveOnBlur}
                          />
                          <label className="form-check-label" htmlFor="offersOnline">
                            Online
                          </label>
                        </div>

                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="offersInPerson"
                            checked={offersInPerson}
                            onChange={(e) => setOffersInPerson(e.target.checked)}
                            onBlur={saveOnBlur}
                          />
                          <label className="form-check-label" htmlFor="offersInPerson">
                            In person
                          </label>
                        </div>
                      </div>
                      <div id="sessionsError" className="text-danger small mt-2" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="headingStyle">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseStyle"
                  aria-expanded="false"
                  aria-controls="collapseStyle"
                >
                  Style
                </button>
              </h2>

              <div
                id="collapseStyle"
                className="accordion-collapse collapse"
                aria-labelledby="headingStyle"
                data-bs-parent="#siteBriefAccordion"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-12 col-md-6">
                      <label className="form-label">Choose a style</label>
                      <div className="form-text">
                        This sets the site colours for buttons, backgrounds, and headings.
                      </div>
                      <select
                        className="form-select"
                        required
                        value={paletteId}
                        onChange={(e) => setPaletteId(e.target.value)}
                        onBlur={saveOnBlur}
                      >
                        {palettes.map((p) => (
                          <option key={p.id} value={p.id}>
                            {p.name}
                          </option>
                        ))}
                      </select>
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12">
                      <div className={`cstyle palette-${paletteId}`}>
                        <div className="row g-2">
                          {swatches.map((s) => (
                            <div key={s.label} className="col-6 col-md-3">
                              <div className="cstyle-swatch">
                                <div className={`cstyle-swatchTop role-${s.label.toLowerCase()}`} />
                                <div className="p-2 small">
                                  <div className="fw-semibold">{s.label}</div>
                                  <div className="text-muted">{s.value}</div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="mt-3">
                          <div className="cstyle-previewHeader">
                            <div className="fw-semibold">Preview area</div>
                            <div className="text-muted small">This is how the colours look together</div>
                          </div>

                          <div className="cstyle-preview">
                            <div className="cstyle-previewSurface">
                              <div className="d-flex align-items-start justify-content-between gap-3 cstyle-previewRow">
                                <div>
                                  <div className="fw-bold">Section</div>
                                  <div className="cstyle-muted small mt-1">
                                    Preview of section background colour with a button example.
                                  </div>
                                  <button type="button" className="cstyle-btn mt-3">
                                    Button
                                  </button>
                                </div>

                                <div className="cstyle-miniCard">
                                  <div className="fw-semibold small">Section</div>
                                  <div className="cstyle-muted small">Preview of section background colour</div>
                                </div>
                              </div>

                              <div className="cstyle-sectionStrip mt-3" />
                              <div className="cstyle-footerBar mt-2" />
                            </div>
                          </div>
                        </div>

                        <div className="mt-4">
                          <label className="form-label">Hero image</label>
                          <div className="form-text">Choose the main header image for your website.</div>

                          <div className="row g-2 mt-2">
                            {heroOptions.map((h) => (
                              <div key={h.id} className="col-6 col-md-4 col-lg-3">
                                <input
                                  type="radio"
                                  className="btn-check"
                                  name="bgImage"
                                  id={`hero-${h.id}`}
                                  checked={bgImage === h.id}
                                  onChange={() => setBgImage(h.id)}
                                  onBlur={saveOnBlur}
                                />
                                <label
                                  className={`btn w-100 p-0 border rounded overflow-hidden ${
                                    bgImage === h.id ? "border-primary" : "border-secondary-subtle"
                                  }`}
                                  htmlFor={`hero-${h.id}`}
                                >
                                  <div className="ratio ratio-16x9">
                                    <img
                                      src={h.src}
                                      alt={h.label}
                                      className="w-100 h-100 object-fit-cover"
                                    />
                                  </div>
                                  <div className="p-2 small text-start">
                                    <div className="fw-semibold">{h.label}</div>
                                  </div>
                                </label>
                              </div>
                            ))}
                          </div>

                          <input type="hidden" name="bgImage" value={bgImage} />
                        </div>
                      </div>
                    </div>

                    <input type="hidden" name="paletteId" value={paletteId} />
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="headingAbout">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseAbout"
                  aria-expanded="false"
                  aria-controls="collapseAbout"
                >
                  About section
                </button>
              </h2>
              <div
                id="collapseAbout"
                className="accordion-collapse collapse"
                aria-labelledby="headingAbout"
                data-bs-parent="#siteBriefAccordion"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-12 col-md-6">
                      <label className="form-label">Display name</label>
                      <div className="form-text">This is the name shown on your site.</div>
                      <input
                        className="form-control"
                        required
                        value={displayName}
                        onChange={(e) => setDisplayName(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="Jane Smith"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12">
                      <label className="form-label">Short intro paragraph</label>
                      <div className="form-text">Two or three sentences is plenty.</div>
                      <textarea
                        className="form-control"
                        rows="3"
                        required
                        value={introBlurb}
                        onChange={(e) => setIntroBlurb(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="I offer a warm and supportive space where you can feel heard and understood."
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12">
                      <label className="form-label">Full About text</label>
                      <div className="form-text">
                        A longer introduction. Include who you work with and what you help with.
                      </div>
                      <textarea
                        className="form-control"
                        rows="5"
                        required
                        value={aboutLong}
                        onChange={(e) => setAboutLong(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="Write a longer introduction about who you are, who you work with, and what you help with."
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Qualifications</label>
                      <div className="form-text">List your key training and qualifications.</div>
                      <textarea
                        className="form-control"
                        rows="3"
                        required
                        value={qualifications}
                        onChange={(e) => setQualifications(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="Level 4 Diploma in Therapeutic Counselling"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Memberships</label>
                      <div className="form-text">For example BACP, UKCP, or similar.</div>
                      <textarea
                        className="form-control"
                        rows="3"
                        required
                        value={memberships}
                        onChange={(e) => setMemberships(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="BACP or similar professional body"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12">
                      <label className="form-label">Areas of focus</label>
                      <div className="form-text">A simple list is fine. These can become bullet points.</div>
                      <textarea
                        className="form-control"
                        rows="3"
                        required
                        value={areasOfFocus}
                        onChange={(e) => setAreasOfFocus(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="Anxiety, low mood, self esteem, grief, life changes"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12">
                      <label className="form-label">Experience</label>
                      <div className="form-text">Mention settings you have worked in and any specialisms.</div>
                      <textarea
                        className="form-control"
                        rows="3"
                        required
                        value={experience}
                        onChange={(e) => setExperience(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="Briefly describe your background and the settings you have worked in."
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="headingServices">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseServices"
                  aria-expanded="false"
                  aria-controls="collapseServices"
                >
                  Services section
                </button>
              </h2>
              <div
                id="collapseServices"
                className="accordion-collapse collapse"
                aria-labelledby="headingServices"
                data-bs-parent="#siteBriefAccordion"
              >
                <div className="accordion-body">
                  <ServicesSection />
                  <div className="mt-3">
                    <label className="form-label">Services intro paragraph</label>
                    <div className="form-text">A short intro that sits above your list of services.</div>
                    <textarea
                      className="form-control"
                      rows="3"
                      required
                      value={servicesIntro}
                      onChange={(e) => setServicesIntro(e.target.value)}
                      onBlur={saveOnBlur}
                      placeholder="A short paragraph introducing how you work and what you offer."
                    />
                    <div className="invalid-feedback">Please fill this in or type NA</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="headingApproach">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseApproach"
                  aria-expanded="false"
                  aria-controls="collapseApproach"
                >
                  Approach section
                </button>
              </h2>
              <div
                id="collapseApproach"
                className="accordion-collapse collapse"
                aria-labelledby="headingApproach"
                data-bs-parent="#siteBriefAccordion"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-12">
                      <label className="form-label">Approach summary</label>
                      <div className="form-text">Explain your approach in a way a new client will understand.</div>
                      <textarea
                        className="form-control"
                        rows="4"
                        required
                        value={approachSummary}
                        onChange={(e) => setApproachSummary(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="Describe your approach and what guides your work."
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12 col-md-4">
                      <label className="form-label">Session length minutes</label>
                      <div className="form-text">Most people put 50 or 60.</div>
                      <input
                        className="form-control"
                        required
                        value={sessionLengthMinutes}
                        onChange={(e) => setSessionLengthMinutes(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="50"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12 col-md-8">
                      <label className="form-label">What to expect</label>
                      <div className="form-text">Include what the first session is like and how sessions usually run.</div>
                      <textarea
                        className="form-control"
                        rows="3"
                        required
                        value={whatToExpect}
                        onChange={(e) => setWhatToExpect(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="What happens in the first session, how sessions usually run, and what clients can expect."
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="headingPricing">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapsePricing"
                  aria-expanded="false"
                  aria-controls="collapsePricing"
                >
                  Pricing section
                </button>
              </h2>
              <div
                id="collapsePricing"
                className="accordion-collapse collapse"
                aria-labelledby="headingPricing"
                data-bs-parent="#siteBriefAccordion"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-12">
                      <label className="form-label">Session fee</label>
                      <div className="form-text">You can include a range if needed.</div>
                      <input
                        className="form-control"
                        required
                        value={sessionFee}
                        onChange={(e) => setSessionFee(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="For example £60"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12">
                      <label className="form-label">Fee notes</label>
                      <div className="form-text">Add anything helpful like payment method or block booking.</div>
                      <textarea
                        className="form-control"
                        rows="3"
                        required
                        value={feeNotes}
                        onChange={(e) => setFeeNotes(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="Any details about packages, payment methods, or session structure."
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Concessions</label>
                      <div className="form-text">If none, type NA.</div>
                      <textarea
                        className="form-control"
                        rows="3"
                        required
                        value={concessions}
                        onChange={(e) => setConcessions(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="Say No if none applicable"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Cancellation policy</label>
                      <div className="form-text">Keep it simple, for example 48 hours notice required.</div>
                      <textarea
                        className="form-control"
                        rows="3"
                        required
                        value={cancellationPolicy}
                        onChange={(e) => setCancellationPolicy(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="For example 48 hours notice required"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="headingContact">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseContact"
                  aria-expanded="false"
                  aria-controls="collapseContact"
                >
                  Contact section
                </button>
              </h2>
              <div
                id="collapseContact"
                className="accordion-collapse collapse"
                aria-labelledby="headingContact"
                data-bs-parent="#siteBriefAccordion"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-12 col-md-6">
                      <label className="form-label">Phone</label>
                      <div className="form-text">Shown on the contact page if you want it there.</div>
                      <input
                        className="form-control"
                        required
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="07... or Say No if none applicable"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Email</label>
                      <div className="form-text">This will be the main contact email on the site.</div>
                      <input
                        className="form-control"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="hello@example.com"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Preferred method</label>
                      <div className="form-text">How you would like people to contact you.</div>
                      <select
                        className="form-select"
                        required
                        value={preferredMethod}
                        onChange={(e) => setPreferredMethod(e.target.value)}
                        onBlur={saveOnBlur}
                      >
                        <option value="email">Email</option>
                        <option value="phone">Phone</option>
                        <option value="either">Either</option>
                      </select>
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Typical reply time</label>
                      <div className="form-text">This helps set expectations for new enquiries.</div>
                      <input
                        className="form-control"
                        required
                        value={replyTime}
                        onChange={(e) => setReplyTime(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="24 to 48 hours"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12">
                      <label className="form-label">What happens next</label>
                      <div className="form-text">Explain what someone should do after they contact you.</div>
                      <textarea
                        className="form-control"
                        rows="3"
                        required
                        value={nextSteps}
                        onChange={(e) => setNextSteps(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="For example send a short message and I will suggest a time for a brief call."
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="headingLinks">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseLinks"
                  aria-expanded="false"
                  aria-controls="collapseLinks"
                >
                  Links section
                </button>
              </h2>

              <div
                id="collapseLinks"
                className="accordion-collapse collapse"
                aria-labelledby="headingLinks"
                data-bs-parent="#siteBriefAccordion"
              >
                <div className="accordion-body">
                  <LinksSection />
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="headingPracticeImages">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapsePracticeImages"
                  aria-expanded="false"
                  aria-controls="collapsePracticeImages"
                >
                  Practice images
                </button>
              </h2>

              <div
                id="collapsePracticeImages"
                className="accordion-collapse collapse"
                aria-labelledby="headingPracticeImages"
                data-bs-parent="#siteBriefAccordion"
              >
                <div className="accordion-body">{id && <PracticeImages user={user} id={id} />}</div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="headingExtra">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseExtra"
                  aria-expanded="false"
                  aria-controls="collapseExtra"
                >
                  Extra details
                </button>
              </h2>
              <div
                id="collapseExtra"
                className="accordion-collapse collapse"
                aria-labelledby="headingExtra"
                data-bs-parent="#siteBriefAccordion"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-12 col-md-6">
                      <label className="form-label">Working hours</label>
                      <div className="form-text">Include days and times, and mention evenings if offered.</div>
                      <input
                        className="form-control"
                        required
                        value={workingHours}
                        onChange={(e) => setWorkingHours(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="For example Mon to Thu 9am to 6pm"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Age range</label>
                      <div className="form-text">For example Adults 18 plus.</div>
                      <input
                        className="form-control"
                        required
                        value={ageRange}
                        onChange={(e) => setAgeRange(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="For example Adults 18 plus"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Online platforms</label>
                      <div className="form-text">For example Teams, Zoom, WhatsApp, or type NA.</div>
                      <input
                        className="form-control"
                        required
                        value={onlinePlatform}
                        onChange={(e) => setOnlinePlatform(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="WhatsApp, Teams, or not applicable"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Accessibility notes</label>
                      <div className="form-text">Mention step free access, lift access, or type NA.</div>
                      <input
                        className="form-control"
                        required
                        value={accessibilityNotes}
                        onChange={(e) => setAccessibilityNotes(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="Say No if none applicable"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>

                    <div className="col-12">
                      <label className="form-label">Parking and travel notes</label>
                      <div className="form-text">Anything a visitor should know before they arrive.</div>
                      <textarea
                        className="form-control"
                        rows="3"
                        required
                        value={parkingNotes}
                        onChange={(e) => setParkingNotes(e.target.value)}
                        onBlur={saveOnBlur}
                        placeholder="Say No if none applicable"
                      />
                      <div className="invalid-feedback">Please fill this in or type NA</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="headingAnythingElse">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseAnythingElse"
                  aria-expanded="false"
                  aria-controls="collapseAnythingElse"
                >
                  Anything else
                </button>
              </h2>

              <div
                id="collapseAnythingElse"
                className="accordion-collapse collapse"
                aria-labelledby="headingAnythingElse"
                data-bs-parent="#siteBriefAccordion"
              >
                <div className="accordion-body">
                  <div className="mb-3">
                    <label className="form-label">Anything else notes</label>
                    <div className="form-text">Anything you want included on your site that we have not covered.</div>
                    <textarea
                      className="form-control"
                      rows="4"
                      required
                      value={anythingElseNotes}
                      onChange={(e) => setAnythingElseNotes(e.target.value)}
                      onBlur={saveOnBlur}
                      placeholder="Anything else you want included on your site"
                    />
                    <div className="invalid-feedback">Please fill this in or type NA</div>
                  </div>

                  <ExtraSectionsSection user={user} />
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex flex-wrap gap-2 mt-4">
            <button type="submit" className="btn btn-primary" disabled={submitting}>
              {submitting ? "Saving" : "Save details"}
            </button>
          </div>

          {submitSuccess ? <div className="text-success small mt-3">Saved successfully</div> : null}
          {submitError ? <div className="text-danger small mt-3">{submitError}</div> : null}
        </div>
      </form>
    </div>
  );
}
